<template>
  <!--字段查看-->
  <div>
    <div class="parser" :style="align ? 'justify-content: space-around;' : ''">
      <div v-if="showlabel && print"
           style="width: 170px;color: #000;font-weight: 600;text-align: left;padding:10px 10px;font-size: 18px;border:solid 1px #000000">
        {{ temp.name }}
      </div>
      <div v-else-if="showlabel && !print"
           style="width: 130px;color: #888;font-weight: 400;text-align: right;padding:10px 10px;font-size: 12px;">
        {{ temp.name }}
      </div>
      <span v-if="datas[temp.key]" style="width: 100%;"
            :style="showlabel && print ? 'padding:10px;color:#000;font-size: 18px;border:solid 1px #000;width:calc(100% - 210px);text-align: left' : showlabel && !print ? 'padding:10px;color:#000;font-size: 14px' : ''">
        <!--地址-->
        <div v-if="temp.type == 'address'">
          {{ datas[temp.key].address }}
        </div>
        <div v-else-if="temp.type == 'login'">
          
          {{ datas[temp.key].name }}
        </div>
        
        <div v-else-if="temp.type == 'activityselect'">
          <span v-if="datas[temp.key] && datas[temp.key].label">
            {{ datas[temp.key].label }}
          </span>
        </div>
        <!--时间-->
        <div v-else-if="temp.type == 'time'">
          <span v-if="temp.is_range">
            {{ u.formatDateTime(3, datas[temp.key][0]) }} - {{ u.formatDateTime(3, datas[temp.key][1]) }}
          </span>
          <span v-else>
            {{ u.formatDateTime(3, datas[temp.key]) }}
          </span>
        </div>
        <!--时间-->
        <div v-else-if="temp.type == 'date'">
          <span v-if="temp.is_range">
            {{ u.formatDateTime(2, datas[temp.key][0]) }} - {{ u.formatDateTime(2, datas[temp.key][1]) }}
          </span>
          <span v-else>
            {{ u.formatDateTime(2, datas[temp.key]) }}
          </span>
        </div>
        <!--时间日期-->
        <div v-else-if="temp.type == 'datetime'">
          <span v-if="temp.is_range">
            {{ u.formatDateTime(1, datas[temp.key][0]) }} - {{ u.formatDateTime(1, datas[temp.key][1]) }}
          </span>
          <span v-else>
            {{ u.formatDateTime(1, datas[temp.key]) }}
          </span>
        </div>
        <div v-else-if="temp.type == 'user'">
          <span v-for="(item2, index2) in datas[temp.key]">
            {{ item2.name }}
          </span>
        </div>
        <div v-else-if="temp.type == 'department'">
          <span v-for="(item2, index2) in datas[temp.key]">
            {{ item2.name }}
          </span>
        </div>
        <div v-else-if="temp.type == 'select'">
          {{ datas[temp.key].label }}
        </div>
        <div v-else-if="temp.type == 'dataselect'">
          {{ datas[temp.key].name }}
        </div>
        <div v-else-if="temp.type == 'checkbox'">
          <span v-for="(item2, index2) in datas[temp.key]">
            {{ item2 }}
          </span>
        </div>
        <div v-else-if="temp.type == 'file'">
          <span v-for="(item2, index2) in datas[temp.key]">
            <span class="btn-txt" @click="dowloadfile(u.config().static + '/' + item2)"><u>{{ item2 }}</u></span>&nbsp;
          </span>
        </div>
        <div v-else-if="temp.type == 'image'" style="display: flex;align-items: center;justify-content: space-around">
          <el-image v-if="datas[temp.key].length > 0" style="width: 30px; height: 30px"
                    :src="u.config().static + '/' + datas[temp.key][0]" :preview-src-list="geturlist(datas[temp.key])">
          </el-image>
          <span v-if="datas[temp.key].length > 0">
            共{{ datas[temp.key].length }}张
          </span>
        </div>
        <div v-else-if="temp.type == 'formtable'">
          <el-button @click="handleDetailsInfo" size="mini">点击查看详情</el-button>
        </div>
        <div v-else>
          {{ temp.prefix }}{{ datas[temp.key] }}{{ temp.suffix }}
        </div>
      </span>
      <span v-else style="padding: 10px;color: #000;font-size: 14px;">{{ datas[temp.key] }}</span>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" width="38%" :visible.sync="dialogDateilVisible" modal-append-to-body append-to-body v-if="temp.type == 'formtable'" style="z-index: 2014;">
      <div v-if="temp.key == 'types'">
        <div>商品类型：</div>
        <!-- <div>{{datas[temp.key].label}}</div>
        <div>{{datas[temp.key].value}}</div> -->
      </div>
      <el-table :data="datas[temp.key]" style="width: 100%" border v-else-if="temp.key == 'values_list'">
        <el-table-column prop="attrs" label="属性值" min-width="70" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="加价(元)" width="75" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sort" label="排序">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import u from "../../../assets/js/util";

export default {
  name: "parser_view",
  props: ["temp", "datas", "option", "showlabel", "align", "print"],
  data() {
    return {
      u,
      dialogDateilVisible: false
    }
  },
  mounted() {
  },
  methods: {
    geturlist(list) {
      var imglist = []
      for (var i = 0; i < list.length; i ++) {
        imglist.push(u.config().static + '/' + list[i])

      }
      return imglist
    },
    dowloadfile(url) {
      window.open(url)
    },
    handleDetailsInfo() {
      // console.log(1, this.datas)
      // console.log(2, this.temp)
      this.dialogDateilVisible = true
    }
  }
}
</script>

<style scoped>
.parser {
  display: flex;
  width: 100%;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/page/module/util/parser_view.vue